<svelte:options
  customElement={{
    tag: "oc-tooltip-v1",
    extend: window.__components.extend(),
    props: {
      position: { type: "String" },
    },
  }}
/>

<script lang="ts">
  import type { Props } from "./TooltipV1.types";
  import DefaultStyles from "../../../common/components/DefaultStyles/DefaultStyles.svelte";

  let { position = "bottom", disabled = false }: Props = $props();

  let contextElement = $state<HTMLElement>();
  let popoverElement = $state<HTMLOcPopoverV1Element>();

  export function recalcPosition(): void {
    popoverElement?.recalcPosition();
  }
</script>

<!-- eslint-disable-next-line svelte/valid-compile -->
<!-- eslint-disable svelte/no-at-html-tags -->
<div class="tooltip-box" bind:this={contextElement}>
  <slot />
</div>
<!-- TODO slop: add configurable label to tooltip attributes -->
<oc-popover-v1
  variant="tooltip"
  {position}
  anchor={disabled ? undefined : contextElement}
  bind:this={popoverElement}
  oc-aria-label="Tooltip"
>
  <slot name="tooltip-content" />
</oc-popover-v1>

<DefaultStyles display="block" />

<style lang="scss">
  @use "../../popover/v1/PopoverV1.global.scss";

  :global {
    :host {
      width: fit-content;
    }
  }
</style>
